import React, { Fragment } from "react";
import { Container } from "reactstrap";
import { Row } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import FeatureSlider from "./FeatureSlider";
import FeatureOfferSlider from "./FeatureOfferSlider";
import Categories from "./Categories";
import Offers from "./Offers";
import NearbyOffers from "./NearbyOffers";
import NearbySubmerchants from "./NearbySubmerchants";
import "./_homepage.scss";
// import FeaturesIcon from "../../components/svg/FeaturesIcon"
// import { useQuery } from "react-query"
// import { ApiNames, fetchData } from "../../remote-data/fetchData"
// import { Link, useHistory } from "react-router-dom";

function DefaultDashboard(props) {
  return (
    <Fragment>
      <div className="top-bg pb-0">
        <FeatureSlider />

        <FeatureOfferSlider />
      </div>

      <Row>
        <Colxx lg="12">
          <Container>
            <Categories />

            <NearbyOffers />

            <Offers />

            <NearbySubmerchants />
          </Container>
        </Colxx>
      </Row>

      <style jsx="true">{`
        .top-bg::after {
          position: absolute;
          bottom: 150px;
        }
      `}</style>
    </Fragment>
  );
}
export default DefaultDashboard;
